import React from "react";

import * as API from "../util/api";
import * as Util from "../util/util";
import VLScreen from "./VLScreen";

export default class FloodAlertsScreen extends VLScreen {

    constructor() {
        super();
        this.state = {loaded: false, floods: []};
    }

    componentDidMount() {
        this.load();
    }

    load = () => {
        API.POST("systems/list", {show_floods: true}, result => {
            Util.handleLogout(result);
            if (result.success) {
                const floods = result.result.floods.filter(f => {
                    return f.severity == this.props.type;
                });

                this.setState({floods});
            } else {
                this.setState({error: result.error});
            }
            this.setState({loaded: true});
        });
    };

    content() {
        return (
            <div id="content" style={{
                justifyContent: "center",
                width: "100%",
                display: "flex",
                height: "auto"
            }}>

                <div style={{
                    width: "25cm",
                    maxWidth: "90vw",
                    justifyContent: "center",
                    flexDirection: "column",
                    alignItems: "center",
                    display: this.state.loaded ? "flex" : "none",
                    margin: "0 auto",
                    height: "auto"
                }}>
                    {this.renderList()}
                </div>
            </div>

        );
    }

    title = () => "Flood Alerts";

    renderList = () => {
        return (
            <div style={{width: "100%"}} className="top8">
                {this.state.floods.map(this.renderFlood)}
            </div>
        );
    };

    renderFlood = (flood) => {
        return (
            <div onClick={() => this.openFlood(flood)} className="hoverable"
                 style={{background: "#33ccff", borderRadius: 16, padding: 16, margin: 16}}>
                <h2 style={{margin: 8}}>{flood.description}</h2>
                <p><i>{flood.areaName}</i></p>
                <p>{flood.message}</p>
		<p>
		  Last Modified: {
		    `${new Date(flood.time * 1000).toLocaleTimeString('en-GB', {
		      hour: '2-digit',
		      minute: '2-digit',
		      timeZone: 'UTC'
		    })} ${new Date(flood.time * 1000).toLocaleDateString('en-GB', {
		      day: 'numeric',
		      month: 'short',
		      year: 'numeric',
		      timeZone: 'UTC'
		    })}`
		  }
		</p>
            </div>);
    };

    openFlood = (flood) => {
        this.props.navigate("/floodArea/" + flood.uid);
    };

}
